export default {"src":"/_next/static/media/google_play.bcf14153.svg","height":102,"width":268,"blurWidth":0,"blurHeight":0};